import { FC, useEffect, useRef } from 'react'
import {
  Box,
  IconBarsThree,
  Button,
  GreyGrey60
} from '@sequencehq/core-components'

import { useNavigationV3Context } from 'components/NavigationV3/hooks/useNavigationV3Context'

/**
 * Page-header burger that opens the navigation as a slide-over drawer. Only
 * rendered on mobile (below `md`); on larger screens the persistent sidebar is
 * always visible so the toggle hides itself. Drop it into any page header.
 */
export const MobileNavToggle: FC = () => {
  const { data, functions } = useNavigationV3Context()
  const buttonRef = useRef<HTMLButtonElement>(null)
  const wasOpen = useRef(false)

  // Closing hides the drawer, so focus would be left on a hidden link (the
  // route-change close). Return it to the trigger, as a dialog does.
  useEffect(() => {
    if (wasOpen.current && !data.isMobileNavOpen) {
      buttonRef.current?.focus()
    }

    wasOpen.current = data.isMobileNavOpen
  }, [data.isMobileNavOpen])

  return (
    <Box display={{ base: 'flex', md: 'none' }}>
      <Button
        ref={buttonRef}
        variant="ghost"
        aria-label="Open navigation"
        onClick={functions.toggleMobileNav}
        icon={<IconBarsThree size={20} color={GreyGrey60} />}
        data-testid="layout.mobileNavToggle"
      />
    </Box>
  )
}
